/**
 * @generated SignedSource<<9456902320c847f654f3cce562adbe36>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AdminMembersReportContentsTabStatisticsCardsQuery$variables = {
  id: string;
  startDate?: string | null;
};
export type AdminMembersReportContentsTabStatisticsCardsQuery$data = {
  readonly node: {
    readonly __typename: "OrganizationMembership";
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"MemberReportContentUsagesAverageVideoWatchProgressStatisticsCardFragment" | "MemberReportContentUsagesViewedStatisticsCardFragment" | "MemberReportSurveysCompletedStatisticsCardFragment">;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null;
};
export type AdminMembersReportContentsTabStatisticsCardsQuery = {
  response: AdminMembersReportContentsTabStatisticsCardsQuery$data;
  variables: AdminMembersReportContentsTabStatisticsCardsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "startDate"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = [
  {
    "kind": "Variable",
    "name": "startDate",
    "variableName": "startDate"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalAvailable",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AdminMembersReportContentsTabStatisticsCardsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              {
                "args": (v4/*: any*/),
                "kind": "FragmentSpread",
                "name": "MemberReportContentUsagesViewedStatisticsCardFragment"
              },
              {
                "args": (v4/*: any*/),
                "kind": "FragmentSpread",
                "name": "MemberReportContentUsagesAverageVideoWatchProgressStatisticsCardFragment"
              },
              {
                "args": (v4/*: any*/),
                "kind": "FragmentSpread",
                "name": "MemberReportSurveysCompletedStatisticsCardFragment"
              }
            ],
            "type": "OrganizationMembership",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AdminMembersReportContentsTabStatisticsCardsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": (v4/*: any*/),
                "concreteType": "OrganizationMembershipReportingContentUsagesViewedReportResponse",
                "kind": "LinkedField",
                "name": "contentUsagesViewedReport",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalViewed",
                    "storageKey": null
                  },
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v4/*: any*/),
                "concreteType": "GenericReportingResponse",
                "kind": "LinkedField",
                "name": "contentUsagesAverageVideoWatchProgressReport",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "allTime",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v4/*: any*/),
                "concreteType": "OrganizationMembershipReportingSurveysCompletedReportResponse",
                "kind": "LinkedField",
                "name": "surveysCompletedReport",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalCompleted",
                    "storageKey": null
                  },
                  (v5/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "OrganizationMembership",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "4ac09e5b38ac855759f11062bfb5cea3",
    "id": null,
    "metadata": {},
    "name": "AdminMembersReportContentsTabStatisticsCardsQuery",
    "operationKind": "query",
    "text": "query AdminMembersReportContentsTabStatisticsCardsQuery(\n  $id: ID!\n  $startDate: String\n) {\n  node(id: $id) {\n    __typename\n    ... on OrganizationMembership {\n      id\n      ...MemberReportContentUsagesViewedStatisticsCardFragment_4sOHZa\n      ...MemberReportContentUsagesAverageVideoWatchProgressStatisticsCardFragment_4sOHZa\n      ...MemberReportSurveysCompletedStatisticsCardFragment_4sOHZa\n    }\n    id\n  }\n}\n\nfragment MemberReportContentUsagesAverageVideoWatchProgressStatisticsCardFragment_4sOHZa on OrganizationMembership {\n  contentUsagesAverageVideoWatchProgressReport(startDate: $startDate) {\n    allTime\n  }\n}\n\nfragment MemberReportContentUsagesViewedStatisticsCardFragment_4sOHZa on OrganizationMembership {\n  contentUsagesViewedReport(startDate: $startDate) {\n    totalViewed\n    totalAvailable\n  }\n}\n\nfragment MemberReportSurveysCompletedStatisticsCardFragment_4sOHZa on OrganizationMembership {\n  surveysCompletedReport(startDate: $startDate) {\n    totalCompleted\n    totalAvailable\n  }\n}\n"
  }
};
})();

(node as any).hash = "7cacef147ca9cce4feec64c5ec45b205";

export default node;
